/* eslint-disable */
import { ORDERS_FIND_BY_ID, ORDERS_FIND_BY_ID_COMPLETE, ORDERS_FIND_BY_ID_ERROR, ORDERS_FIND_BY_ID_SUCCESS } from '../Orders.types';

/**
 * Fetch a specific `order` by its `id`
 * @param {OrderServiceFindByIdDto} dto The required params to find an order by its `id`
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersFindById = ({ date, orderCode, orderLine }) => ({ orderService, fromPromise, getState }) => {
  const state = getState();
  const promise = orderService.findById({ date, orderCode, orderLine, state });
  return fromPromise(promise, { params: { date, orderCode, orderLine } }, [
    ORDERS_FIND_BY_ID,
    ORDERS_FIND_BY_ID_COMPLETE,
    ORDERS_FIND_BY_ID_ERROR,
    ORDERS_FIND_BY_ID_SUCCESS,
  ]);
};

export default ordersFindById;
